import React from "react";
import Logo from "../components/Logo";
import BackButton from "../components/BackButton";
import { Button } from "../components/ui/button";
import { Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { WaitlistDialog } from "@/components/WaitlistDialog";

const CallToAction = () => {
  const navigate = useNavigate();
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);

  return (
    <div className="min-h-[100dvh] flex flex-col items-center p-6">
      <BackButton />
      <div className="w-full max-w-4xl mx-auto relative">
        <Logo />
        <div className="mt-12 space-y-8 text-center">
          <h1 className="text-5xl font-bold bg-gradient-to-r from-black to-gray-700 bg-clip-text text-transparent animate-fade-up opacity-0" style={{ animationDelay: "0.2s" }}>
            Got Offers?
          </h1>
          <h2 className="text-3xl font-semibold text-black animate-fade-up opacity-0" style={{ animationDelay: "0.3s" }}>
            Join EatsBoost Today and Redefine Your Dining
          </h2>
          
          <div className="relative py-6 px-8 bg-eatsboost-orange/20 rounded-lg border-2 border-eatsboost-orange shadow-lg animate-scale-in opacity-0 -mb-4" style={{ animationDelay: "0.35s" }}>
            <p className="text-lg text-gray-800">
              <span className="font-bold">Limited-time Offer</span>: Get a <span className="font-bold">Level 3</span> welcome offer—<span className="font-bold">up to 15% off</span> your next visit—when you purchase a Boost Card and add an eatery
            </p>
          </div>

          <div className="relative py-6 px-8 bg-[#D3E4FD] rounded-lg border-2 border-blue-300 shadow-lg animate-scale-in opacity-0 -mb-4" style={{ animationDelay: "0.4s" }}>
            <p className="text-lg text-gray-800">
              <span className="font-bold">Limited Availability:</span> Each eatery only has a limited number of <span className="font-bold">Boost Cards</span>. Once they're gone, no more will be issued. <span className="font-bold">Secure</span> your very own today!
            </p>
          </div>

          <div className="mt-16 p-6 border-2 border-gray-200 rounded-lg shadow-sm animate-fade-up opacity-0" style={{ animationDelay: "0.45s" }}>
            <p className="text-xl text-gray-700">
              Ask the server for a Boost Card and Download the App!
            </p>
            <p className="text-sm text-gray-600 mt-4">
              Available on iOS and Android
            </p>
          </div>
          
          <Button 
            onClick={() => navigate("/available-eateries")}
            className="bg-[#2E7D32] hover:bg-[#2E7D32]/90 text-white text-xl px-10 py-6 rounded-md w-auto font-bold animate-fade-up opacity-0"
            style={{ animationDelay: "0.47s" }}
          >
            Find More Eateries 📍
          </Button>

          <WaitlistDialog 
            open={isDialogOpen}
            onOpenChange={setIsDialogOpen}
          />
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
